const NEXTDOM = 'nextSibling';
const PREVDOM = 'previousSibling';

const parent = function(el) {
  return el.parentNode;
}

const children = function(el) {
  return el.children;
}

const first = function(el) {
  return el.children ? el.children[0] : null;
}

const last = function(el) {
  return el.children ? el.children[el.children.length - 1] : null;
}

const prev = function(el) {
  return getDom(el, PREVDOM);
}

const next = function(el) {
  return getDom(el, NEXTDOM);
}

function getDom(el, attr) {
  let element = el[attr];
  if (element.nodeType != 1) {
    return getDom(element, attr);
  }
  return element;
}

const find = function(prop, els) {
  let filter = Array.prototype.filter;
  return filter.call(els, function(item) { return item.getAttribute(prop) });
}

const m = {
  parent,
  children,
  first,
  last,
  prev,
  next,
  find
}

module.exports = m;